document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector("#ProductGridContainer");
  if (!container) return;

  const grid = container.querySelector("#product-grid");
  const btn = container.querySelector("[data-load-more]");
  const status = container.querySelector("[data-load-status]");
  if (!grid || !btn) return;

  const seen = new Set();

  const getKeyFromItem = (li) => {
    const a = li.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute("href") : null;
  };

  const getLoadedCount = () => grid.querySelectorAll("li.grid__item").length;

  grid.querySelectorAll("li.grid__item").forEach((li) => {
    const key = getKeyFromItem(li);
    if (key) seen.add(key);
  });

  const total = Number(btn.getAttribute("data-total")) || 0;

  const showButton = (nextUrl = null) => {
    btn.hidden = false;
    btn.style.display = "";
    btn.disabled = false;
    btn.removeAttribute("aria-busy");
    btn.textContent = "More Books";
    if (nextUrl) btn.setAttribute("data-next-url", nextUrl);
  };

  const hideButton = () => {
    btn.hidden = true;
    btn.style.display = "none";
    btn.disabled = true;
    btn.removeAttribute("aria-busy");
    btn.removeAttribute("data-next-url");
  };

  const setLoading = () => {
    btn.hidden = false;
    btn.style.display = "";
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");
    btn.textContent = "Loading books…";
  };

  const updateStatus = () => {
    const loaded = getLoadedCount();
    if (!status) return loaded;
    status.textContent = total
      ? `${loaded}/${total} books loaded`
      : `${loaded} books loaded`;
    return loaded;
  };

  const maybeFinish = () => {
    const loaded = updateStatus();
    if (total && loaded >= total) {
      hideButton();
      return true;
    }
    return false;
  };

  const getNextUrlFromDocument = (doc) => {
    const nextLink =
      doc.querySelector('.pagination a[aria-label="Next page"]') ||
      doc.querySelector(".pagination__item--next.pagination__item-arrow") ||
      doc.querySelector(".pagination a.pagination__item--next");
    return nextLink ? nextLink.getAttribute("href") : null;
  };

  if (!maybeFinish()) {
    const nextUrl = btn.getAttribute("data-next-url");
    if (!nextUrl) hideButton();
    else showButton(nextUrl);
  }

  btn.addEventListener("click", async () => {
    const nextUrl = btn.getAttribute("data-next-url");
    if (!nextUrl) {
      hideButton();
      return;
    }

    try {
      setLoading();

      const res = await fetch(nextUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newItems = Array.from(
        doc.querySelectorAll("#product-grid li.grid__item")
      );

      let appended = 0;

      newItems.forEach((li) => {
        const key = getKeyFromItem(li);
        if (!key) return;

        if (!seen.has(key)) {
          seen.add(key);
          grid.appendChild(li);
          appended += 1;
        }
      });

      if (maybeFinish()) return;

      const nextFromFetchedPage = getNextUrlFromDocument(doc);

      if (!nextFromFetchedPage || appended === 0) {
        hideButton();
      } else {
        showButton(nextFromFetchedPage);
      }
    } catch (e) {
      console.error("Load more failed:", e);
      showButton(btn.getAttribute("data-next-url"));
    }
  });
});